import { useEffect } from 'react';
import '../../../../shared/src/common/css/scheduler.css';
import SchedulerSteps from '@leadflow/shared/src/feature/scheduler/components/SchedulerStep/SchedulerSteps';
import ThemeProviderWrapper from '../../theme/ThemeContext';
import { SchedulerConfig } from '@leadflow/shared/src/Interface/scheduler/form';
import { FormProvider } from '@leadflow/shared/src/common/contexts/FormContext';
import { SharedStateProvider } from '@leadflow/shared/src/common/contexts/SharedStateContext';
import { useFormConfigContext } from '@leadflow/shared/src/common/contexts/FormConfigContext';

interface HTMLElementWithContent extends HTMLElement {
  textContent: string;
}

const App = () => {
  const { setFormConfig } = useFormConfigContext();
  useEffect(() => {
    const mdgInlineFormConfig = document.getElementById(
      'data',
    ) as HTMLElementWithContent | null;
    if (mdgInlineFormConfig?.textContent) {
      try {
        const mdgJsonData = JSON.parse(
          mdgInlineFormConfig.textContent,
        ) as SchedulerConfig;
        if (mdgJsonData?.conceptid) {
          const stepOrder = mdgJsonData.steps?.sort(
            (a, b) => Number(a.sequence) - Number(b.sequence),
          );
          const visibleSteps = stepOrder?.filter((step) => !step.hideStep);
          setFormConfig({ ...mdgJsonData, steps: visibleSteps });
        }
      } catch (error) {
        console.error('Failed to parse JSON:', error);
      }
    } else {
      fetch('/config-files/_scheduler-config.json')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((mdgData) => {
          if (mdgData?.steps) {
            const stepOrder = mdgData.steps?.sort(
              (a, b) => Number(a.sequence) - Number(b.sequence),
            );
            const visibleSteps = stepOrder.filter((step) => !step.hideStep);
            setFormConfig({ ...mdgData, steps: visibleSteps });
          }
        })
        .catch((error) => console.error('Error fetching MDG config:', error));
    }
  }, []);

  return (
    <ThemeProviderWrapper>
      <FormProvider>
        <SharedStateProvider>
          <SchedulerSteps />
        </SharedStateProvider>
      </FormProvider>
    </ThemeProviderWrapper>
  );
};
export default App;
